module.exports = __webpack_public_path__ + "static/media/household_door_glass_panel_internal_open.8acb2cdb.wav";